import { render } from "./StockLogs.vue?vue&type=template&id=b45e4542&scoped=true"
import script from "./StockLogs.vue?vue&type=script&lang=js"
export * from "./StockLogs.vue?vue&type=script&lang=js"

import "./StockLogs.vue?vue&type=style&index=0&id=b45e4542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45e4542"]])

export default __exports__